import React from 'react';
import { get, map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { DATA_TYPES } from 'constants/common';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getDisplayValue } from 'resolvers/formatValue';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';
import { inputField as InputField } from 'ui/views/generic/inputField';

/********************************** */

// success view
const _memberDetailsPayBalanceSetAmount = ( props ) => {
	return (
		<div className="ui-pay-balance-set-amount">
			
			{/* header view */}
			{/* <div className="ui-pay-balance-set-amount__header">
				<div className="ui-pay-balance-set-amount__header__subtitle">
					{ getLabel( props.subtitle ) }
				</div>
			</div> */}

			{/* body view */}
			<div className="ui-pay-balance-set-amount__body">
				
				{/* members (cost selection) */}
				<div className='ui-pay-balance-set-amount__body__members'>
					{
						map( props.members, ( member ) => {
							return (
								<div key={ member.id } className='ui-pay-balance-set-amount__body__members__item'>

									{/* radio input */}
									<div className='ui-pay-balance-set-amount__body__members__item__checkbox' onClick={ () => props.onMemberSelect( { member } ) }>
										<Checkbox size="xl" value={ member.selected } />
									</div>

									{/* field */}
									{
										map( props.fields, ( field ) => {

											// field class name
											const fieldClassName = classnames( 'ui-pay-balance-set-amount__body__members__item__field', {
												'ui-pay-balance-set-amount__body__members__item__field--disabled': ! member.selected,
											} );

											// label class name
											const labelClassName = classnames( 'ui-pay-balance-set-amount__body__members__item__field__label', {
												'ui-pay-balance-set-amount__body__members__item__field__label--selectable': DATA_TYPES.RADIO === field.type,
											} );

											// check if field is selected
											const isFieldSelected = DATA_TYPES.RADIO === field.type && get( member[ field.name ], 'selected', false );

											return (
												<div key={ field.name } className={ fieldClassName }>

													{/* label */}
													<div className={ labelClassName } onClick={ () => props.onRadioFieldSelect( { member, field } ) }>
														{/* radio */}
														{
															DATA_TYPES.RADIO === field.type ? (
																<div className='ui-pay-balance-set-amount__body__members__item__field__label__radio'>
																	<RadioBox selected={ isFieldSelected } />
																</div>
															) : null
														}

														{/* label text */}
														<div className='ui-pay-balance-set-amount__body__members__item__field__label__text'>
															{ getLabel( field.title ) }
														</div>
													</div>

													<div className='ui-pay-balance-set-amount__body__members__item__field__value'>
														{ ( () => {
															if( 'amount' === field.name ) {
																return (
																	<div className='ui-pay-balance-set-amount__body__members__item__field__value__text'>
																		{ getDisplayValue( {
																			type: DATA_TYPES.CURRENCY,
																			value: get( member[ field.name ], 'value', 0 ),
																		} ) }
																	</div>
																);
															} else if( 'definedAmount' === field.name ) {
																return (
																	<div className='ui-pay-balance-set-amount__body__members__item__field__value__input'>
																		<InputField
																			className='ui-pay-balance-set-amount__body__members__item__field__value__input__control'
																			disabled={ ! isFieldSelected }
																			value={ get( member[ field.name ], 'value', '' ) }
																			onChange={ ( { value } ) => props.onDefinedAmountChange( { member, field, value } ) }
																			prefix='$'
																			showLabel={ false }
																		/>
																	</div>
																);
															} else {
																return (
																	<div className='ui-pay-balance-set-amount__body__members__item__field__value__text'>
																		{ member[ field.name ] }
																	</div>
																);
															}
														} )() }
													</div>
												</div>
											);
										} )
									}
								</div>
							);
						} )
					}
				</div>

			</div>
		</div>
	);
};

// set display name
_memberDetailsPayBalanceSetAmount.displayName = 'memberDetailsPayBalanceSetAmount';

// set default props
_memberDetailsPayBalanceSetAmount.defaultProps = {};

// prop types
_memberDetailsPayBalanceSetAmount.propTypes = {};

/***********************************************/

// preloader view
const memberDetailsPayBalanceSetAmountPreloader = () => {
	return (
		<div className="ui-member-details-savings-retail-prescription-widget-preloader">
			<TableSearchInlineWidgetPreloader className="ui-member-details-savings-retail-prescription-widget-preloader__table-preloader" />
		</div>
	);
};

// set display name
memberDetailsPayBalanceSetAmountPreloader.displayName = 'memberDetailsPayBalanceSetAmountPreloader';

// set default props
memberDetailsPayBalanceSetAmountPreloader.defaultProps = {};

// prop types
memberDetailsPayBalanceSetAmountPreloader.propTypes = {};

/***********************************************/

export const memberDetailsPayBalanceSetAmount = withNetworkState( memberDetailsPayBalanceSetAmountPreloader, _memberDetailsPayBalanceSetAmount );
